export default __webpack_public_path__ + "static/media/etape3_book.8e68cb9d.webp";